import * as cleanerV2 from './m2m-cleaning.cleaner-v2';
import * as cleanerV3 from './m2m-cleaning.cleaner-v3';
import * as cleanerV4 from './m2m-cleaning.cleaner-v4';
export const m2mCleaning = {
  cleanerV2,
  cleanerV3,
  cleanerV4
};
